$(document).ready(function() {
  $('#show-form').click(function() {
    $(this).toggle()
  });

  $('#hide-form').click(function() {
    $('#show-form').toggle()
  });
})
